import Vue from 'vue'
import { mapState } from 'vuex'
import BigNumber from 'bignumber.js'
import { CURRENCY_FIELD_BACKEND_ID } from '@/constants/currency'
import { GigTimeTypes } from '@/constants/gig/gigTimeTypes'
import ratesMixin from '@/mixins/ratesMixin'
import { RootState } from '@/store'
import { convertToUsd, getCurrency } from '@/utils-ts/currencies'
import { addDays, addSeconds, convertToLocal, formatDate } from '@/utils/date'
import { formatCurrency } from '@/utils/moneyFormat'

const EXTRA_DAYS = 2
const DATE_FORMAT = 'MMMM Do, YYYY hh:mm A'

export default Vue.extend<any, any, any, any>({
  mixins: [ratesMixin],
  computed: {
    ...mapState<RootState>({
      application: (state: RootState) => state.gigChat.application.value,
    }),
    isHourly() {
      return this.application.gig.timeType === GigTimeTypes.HOURLY
    },
    currency() {
      return getCurrency({
        blockchain: this.application.job.blockchain,
        value: this.application.job.currency,
        field: CURRENCY_FIELD_BACKEND_ID,
      })
    },
    currencyImage() {
      return this.currency?.imageURL || '/static/images/blockchain/currencies/empty.svg'
    },
    circle() {
      return this.currency?.name === 'BRUSH'
    },
    escrowBalance() {
      return new BigNumber(this.application.job.escrow_balance).dividedBy(this.currency.baseUnits)
    },
    escrowBalanceFormatted() {
      return formatCurrency(this.escrowBalance, { currency: this.currency })
    },
    escrowBalanceInUsd() {
      return this.rates.length
        ? convertToUsd({ value: this.escrowBalance, currency: this.currency, rates: this.rates, format: true })
        : null
    },
    deadline() {
      return addSeconds(convertToLocal(this.application?.job?.created_at), this.application.offer?.deadline)
    },
    refundDate() {
      return addDays(this.deadline, EXTRA_DAYS)
    },
  },
  methods: {
    getFormattedDate(date: Date) {
      return formatDate(date, DATE_FORMAT)
    },
  },
})
